<div
  class="floating-tabs"
  [ngClass]="{
    'floating-tabs--vertical': verticalDisplay,
    'floating-tabs--no-wrap': noWrap
  }"
>
  <!-- name attribute is used in ftr-integration and to keep the button width constant when selected or deselected -->
  @for (tab of tabs; track tab) {
    <button
      [class]="'floating-tabs__tab floating-tabs__tab--' + colorSet"
      [ngClass]="{
        'floating-tabs--margin': margins,
        'floating-tabs--shrink': tab.headerLabel,
        'floating-tabs--no-shrink': !tab.headerLabel,
        'floating-tabs__tab--vertical': verticalDisplay
      }"
      [attr.aria-pressed]="tab.value === selectedValue ? 'true' : 'false'"
      (click)="handleTabClick(tab)"
      data-track
      [name]="getLabel(tab.mobileLabel, tab.label)"
      [title]="tab.title ?? ''"
      [attr.aria-label]="tab.ariaLabel ?? ''"
    >
      <div class="floating-tabs__tab__content">
        @if (tab.beforeLabelIcon) {
          @if (tab.beforeLabelIcon.isButton) {
            <button
              [title]="tab.beforeLabelIcon.buttonTitle ?? ''"
              (click)="handleTabClick(tab)"
              ftrButton
              ftrStopPropagation
              [displayType]="buttonDisplayType.Icon"
              [size]="buttonSize.Small"
              (click)="handleBeforeLabelIconClick(tab)"
              type="button"
            >
              <ng-container *ngTemplateOutlet="beforeLabelIcon"></ng-container>
            </button>
          } @else {
            <ftr-icon
              align="Bottom"
              [color]="tab.beforeLabelIcon!.iconColor"
              [icon]="tab.beforeLabelIcon!.icon"
              [interactive]="!!tab.beforeLabelIcon.isButton"
            ></ftr-icon>
          }
          <ng-template #beforeLabelIcon
            ><ftr-icon
              align="Bottom"
              [color]="tab.beforeLabelIcon!.iconColor"
              [icon]="tab.beforeLabelIcon!.icon"
              [interactive]="!!tab.beforeLabelIcon.isButton"
            ></ftr-icon
          ></ng-template>
        }
        <div
          class="floating-tabs__tab__content__label"
          [ngClass]="{
            'floating-tabs__tab__content__label--bold ': boldAllLabels,
            'floating-tabs__tab__content__label--vertical ': verticalDisplay
          }"
        >
          @if (tab.headerLabel) {
            <div class="floating-tabs__tab__content__label floating-tabs__tab__content__label--header">
              {{ tab.headerLabel }}
            </div>
          }
          <span>
            {{ getLabel(tab.mobileLabel, tab.label) }}
          </span>
          @if (tab.footerLabel) {
            <div class="floating-tabs__tab__content__label floating-tabs__tab__content__label--footer">
              {{ tab.footerLabel }}
            </div>
          }
        </div>
        @if (tab.count !== undefined) {
          <ftr-badge [text]="tab.count.toString()" [color]="getBadgeColor(tab.value)"></ftr-badge>
        }
        @if (tab.afterLabelIcon) {
          @if (tab.afterLabelIcon.isButton) {
            <button
              [title]="tab.afterLabelIcon.buttonTitle ?? ''"
              ftrButton
              ftrStopPropagation
              [displayType]="buttonDisplayType.Icon"
              [size]="buttonSize.Small"
              type="button"
              (click)="handleAfterLabelIconClick(tab)"
            >
              <ng-container *ngTemplateOutlet="afterLabelIcon"></ng-container>
            </button>
          } @else {
            <ftr-icon
              align="Bottom"
              [color]="tab.afterLabelIcon!.iconColor"
              [icon]="tab.afterLabelIcon!.icon"
              [interactive]="!!tab.afterLabelIcon.isButton"
            ></ftr-icon>
          }
          <ng-template #afterLabelIcon
            ><ftr-icon
              align="Bottom"
              [color]="tab.afterLabelIcon!.iconColor"
              [icon]="tab.afterLabelIcon!.icon"
              [interactive]="!!tab.afterLabelIcon.isButton"
            ></ftr-icon
          ></ng-template>
        }
      </div>
    </button>
  }
</div>
